import number30 from "../../assets/images/inicio/numero 30.png";
import map from "../../assets/images/inicio/mapa mexico.png";
import "./ImagesInfo.css";
import { Link } from "react-router-dom";

const ImagesInfo = () => {
  return (
    <div className="images-info-container">
      {/* Imagen grande izquierda */}
      <div className="left-image-wrapper">
        <img
          className="background-map"
          src={map}
          alt="Mapa de México"
          loading="lazy"
        />

        {/* <div className="left-text-block">
          Somos un medio nacional de <b>comunicación y promoción</b> de las
          empresas del <b className="highlight">Sector Transporte</b>.
          <div className="read-more">Leer más</div>
        </div> */}

        <div className="left-text-block">
          Somos un medio nacional de <b>comunicación y promoción</b> de las
          empresas del <b className="highlight">Sector Transporte</b>.
          {/* <span className="read-more">Leer más</span> */}
          <Link
            onClick={() => window.scrollTo(0, 0)}
            to="/somos"
            className="read-more"
          >
            Leer más
          </Link>
        </div>
      </div>

      {/* Bloque verde con imagen adentro */}
      <div className="right-green-block">
        <img src={number30} alt="Número 30" loading="lazy" />
      </div>
    </div>
  );
};

export default ImagesInfo;
